import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { initSentry } from "@/lib/telemetry/sentry"
import { App } from "./app"
import "./globals.css"
import "driver.js/dist/driver.css"
import "./styles/tour-theme.css"

initSentry()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
